export enum AppNameEnum {
  POINT_OF_SALE = 'Point of Sale',
  QUICK_PAY = 'Quick Pay',
  REPORTS = 'Reports',
  TRANSACTIONS = 'Transactions',
  INVENTORY = 'Inventory',
  MENU = 'Menu',
  CUSTOMERS = 'Customers',
  ORDERS = 'Orders',
  EBT_TRANSACTIONS = 'EBT Transactions',
  SETTINGS = 'Settings',
  INVOICE = 'Invoice',
  MARKETPLACE = 'Marketplace',
  NOTIFICATIONS = 'Notifications',
  CASH_APP = 'Cash App',
  PAYMENTS = 'Payments',
  ADMIN_PAGE = 'Admin Page',
  PLATFORM_OPS = 'Platform Ops',
  POS_SIDE_DISPLAY = 'POS Side Display',
  TV_MENU_DISPLAY = 'TV Menu Display',
  POINT_OF_SALE_V4 = 'Point of Sale V4',
  /** Remote Config compatibility value used by older mobile-app allowlists. */
  LEGACY_POINT_OF_SALE_V3 = 'Point of Sale V3',
  RESTAURANT_POS_V4 = 'Restaurant POS',
  INVENTORY_V4 = 'Inventory - V4',
  MOBILE_INVENTORY_V4 = 'Mobile Inventory',
  QUICK_PAY_V4 = 'Quick Pay V4',
  INVENTORY_TOOLS = 'Inventory Tools',
  TRANSACTIONS_V4 = 'Transactions V4',
  TIME_CLOCK = 'Time Clock',
}
